import RowActionsMenu from '../shared/RowActionsMenu'

interface Props {
  /** Used for the trigger's accessible name. */
  metricName: string
  open: boolean
  /** Toggle this row's menu. Open state is owned by the table so opening one
   *  row's menu closes any other. */
  onToggle: () => void
  onClose: () => void
  onCreateTopic: () => void
}

// Task #644: per-row actions menu for the in-meeting Scoreboard table. The
// trigger, dropdown and event-swallowing behavior live in the shared
// RowActionsMenu (task #798) so Rock Review renders the identical control;
// this keeps the Scoreboard's metric-flavored prop name.
export default function ScoreboardRowMenu({ metricName, open, onToggle, onClose, onCreateTopic }: Props) {
  return (
    <RowActionsMenu
      itemName={metricName}
      open={open}
      onToggle={onToggle}
      onClose={onClose}
      onCreateTopic={onCreateTopic}
    />
  )
}
